import { render, staticRenderFns } from "./error.vue?vue&type=template&id=6c6eb6e6&scoped=true"
import script from "./error.vue?vue&type=script&setup=true&lang=ts"
export * from "./error.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./error.vue?vue&type=style&index=0&id=6c6eb6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6eb6e6",
  null
  
)

export default component.exports